export default "__VITE_ASSET__C93tuJOK__"